import { lazy } from 'react';
import noInternetConnection from 'sections/dialogs/noInternetConnection';

const dialogs = {
  info: lazy(() => import('sections/dialogs/info')),
  error: lazy(() => import('sections/dialogs/error')),
  QRCode: lazy(() => import('sections/dialogs/QRCode')),
  playGame: lazy(() => import('sections/dialogs/playGame')),
  lowBalance: lazy(() => import('sections/dialogs/lowBalance')),
  notVerified: lazy(() => import('sections/dialogs/notVerified')),
  metamaskNetworkChanged: lazy(() => import('sections/dialogs/metamaskNetworkChanged')),
  channelNotCreated: lazy(() => import('sections/dialogs/channelNotCreated')),
  needToLogin: lazy(() => import('sections/dialogs/needToLogin')),
  needToSign: lazy(() => import('sections/dialogs/needToSign')),
  unauthorized: lazy(() => import('sections/dialogs/unauthorized')),
  securityInfo: lazy(() => import('sections/dialogs/securityInfo')),
  cancelWithdraw: lazy(() => import('sections/dialogs/cancelWithdraw')),
  noInternetConnection,
};

export default dialogs;
